import { render, staticRenderFns } from "./Fieldset.vue?vue&type=template&id=240ada58&scoped=true&"
import script from "./Fieldset.vue?vue&type=script&lang=ts&"
export * from "./Fieldset.vue?vue&type=script&lang=ts&"
import style0 from "./Fieldset.vue?vue&type=style&index=0&id=240ada58&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "240ada58",
  null
  
)

export default component.exports